import { useQuery } from '@tanstack/react-query'
import { llmReasoningApi } from '../api/client'
import './LLMEnvelopeView.css'

export function LLMEnvelopeView() {
  const q = useQuery({
    queryKey: ['llm-reasoning-envelope-view'],
    queryFn: llmReasoningApi.envelope,
    refetchInterval: 60000,
  })

  return (
    <div className="card llm-envelope-view">
      <h3>LLM envelope</h3>
      {q.isLoading && <p className="llm-muted">Loading…</p>}
      {q.isError && <p className="llm-muted">Failed to load envelope.</p>}
      {q.data && (
        <>
          {Object.keys(q.data.envelope_spec).length === 0 ? (
            <p className="llm-muted">
              No envelope configured — all goal proposals route to human review.
            </p>
          ) : (
            <table className="llm-env-table">
              <thead>
                <tr>
                  <th>Goal type</th>
                  <th>Min</th>
                  <th>Max</th>
                  <th>Max step / cycle</th>
                  <th>Cool-down</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(q.data.envelope_spec).map(([goalType, spec]) => (
                  <tr key={goalType}>
                    <td>{goalType}</td>
                    <td>{(spec.min ?? 0).toString()}</td>
                    <td>{(spec.max ?? 0).toString()}</td>
                    <td>{(spec.max_step_per_cycle ?? 0).toString()}</td>
                    <td>{(spec.cool_down_seconds ?? 0).toString()}s</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <p className="llm-muted llm-env-foot">
            Precedent decay: {q.data.precedent_decay_days}d ·
            negative window: {q.data.precedent_negative_window_days}d
          </p>
        </>
      )}
    </div>
  )
}
